import React from 'react'
import styled from 'styled-components'
import StyledText from '../../components/StyledComponents/StyledText';
import { useTheme } from '../../middleware/ThemeContext';
import PlaceholderImage from "../../assets/images/placeholder-image.jpg";
import StyledToolTip from '../../components/StyledComponents/StyledTooltip';
import MinusCircleIcon from '../../assets/icons/MinusCircleIcon';
import { Button } from '../../components/form/Button';
import { useNavigate } from 'react-router-dom';

interface SingleCriteriaResultBox {
    openPopup: () => void;
    data: any[];
    criteria: string[];
    index: number;
    setDataKey: (item: number) => void;
    scope: 'Contact' | 'ORGANIZATION';
}

const SingleCriteriaResultBox: React.FC<SingleCriteriaResultBox> = ({ openPopup, data, criteria, index, setDataKey, scope }) => {
    const {theme} = useTheme();
    const navigate = useNavigate();
    const ids = data.map(item => item.id).join(",");
    const handelMerge = () => {
        scope == 'Contact' ?
            navigate(`/home/contacts/merge?ids=${ids}`) :
        scope == 'ORGANIZATION' ?
            navigate(`/home/organizations/merge?ids=${ids}`) :
            navigate('home/duplicate-checker/')
    }
  return (
    <BoxContainer theme={theme}>
        <BoxHeader theme={theme}>
            <div className='d-flex gap-1'>
                <StyledText fontSize='16px' fontWeight={700}>
                    {data.slice(0, 1).map((item, index) => {
                        let display = "";
                        
                        if(scope == 'Contact') {
                            if (criteria.includes("firstName") && criteria.includes("lastName")) {
                                display = `${item.firstName !== null ? item.firstName : '-'} ${item.lastName !== null ? item.lastName : '-'}`;
                            } else if (criteria.includes("firstName")) {
                                display = item.firstName !== null ? item.firstName : '-';
                            } else if (criteria.includes("lastName")) {
                                display = item.lastName !== null ? item.lastName : '-';
                            } else if (criteria.includes("email")) {
                                display = item.email;
                            }
                        } else if (scope == 'ORGANIZATION') { 
                            if (criteria.includes("name")) {
                                display = item.name;
                            }
                        }

                        return (
                            <span key={index}>
                            {display}
                            </span>
                        );
                    })}
                </StyledText>
                <StyledText fontSize='16px' fontWeight={700} textColor={theme.CorporateTheme.colors.count}>
                    ({data.length})
                </StyledText>
            </div>
            <div className='d-flex'>
                <UserImages theme={theme}>
                    {data.slice(0, 5).map((item, index) => (
                        <span key={index}>
                            <img
                                src={item.signedUrl || PlaceholderImage}
                                alt={item.firstName}
                                onError={(e) => {
                                    (e.target as HTMLImageElement).src = PlaceholderImage;
                                }}
                            />
                        </span>
                    ))}
                    {data.length > 5 && (
                        <span className='img-avatar'>
                            +{data.length - 5}
                        </span>
                    )}
                </UserImages>
                <Divider theme={theme} style={{ height: '25px', margin: '0px 15px' }} />
                <div onClick={() => { setDataKey(index); openPopup(); }}>
                    <StyledToolTip title='Ignore'>
                        <MinusCircleIcon color={theme.CorporateTheme.colors.headerColor} />
                    </StyledToolTip>
                </div>
            </div>
        </BoxHeader>
        <div style={{ padding: '20px 15px' }}>
            <StyledText fontSize='14px' fontWeight={400} textColor={theme.CorporateTheme.colors.textSecondary} style={{ marginBottom: '10px' }}>
                Quick Overview
            </StyledText>
            <ConCriteria theme={theme}>
                <div>
                    <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.textSecondary} style={{ lineHeight: '20px' }}>
                        Duplicate Criteria
                    </StyledText>
                    <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                        {criteria.map((cri, index) => (
                            <span key={index}>
                                {
                                    scope === 'Contact' ? (
                                        cri === 'firstName' ?
                                        'First Name' :
                                        cri === 'lastName' ?
                                        'Last Name' :
                                        cri === 'email' ?
                                        'Email' : null
                                    ) : scope === 'ORGANIZATION' ? (
                                        cri === 'name' ?
                                        'Organization Name'
                                        :
                                        ''
                                    ) : null
                                }
                                {index < criteria.length - 1 && ', '}
                            </span>
                        ))}
                    </StyledText>
                </div>
                <Divider theme={theme} style={{ height: '25px' }} />
                <div>
                    <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.textSecondary} style={{ lineHeight: '20px' }}>
                        Match Type
                    </StyledText>
                    <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                        {scope === 'ORGANIZATION' || criteria.includes('email') ? 
                            'Fuzzy Match' :
                            'Exact Match'    
                        }
                    </StyledText>
                </div>
                <Divider theme={theme} style={{ height: '25px' }} />
                <div>
                    <StyledText fontSize='12px' fontWeight={600} textColor={theme.CorporateTheme.colors.textSecondary} style={{ lineHeight: '20px' }}>
                        Duplicate Found
                    </StyledText>
                    <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>
                        {data.length}
                    </StyledText>
                </div>
            </ConCriteria>
            <div className='d-flex justify-content-end mt-3'>
                <Button theme={theme} type="submit" $variant="add" onClick={() => handelMerge()}>
                    Merge Duplicates
                </Button>
                {/* <Button theme={theme} type="button" $variant="cancel">
                    Ignore
                </Button> */}
            </div>
        </div>
    </BoxContainer>
  )
}

const BoxContainer = styled.div`
    background-color: ${({theme}) => theme.colors.contentBackground};
    border: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    border-radius: 5px;
    // width: 456px;
`;

const BoxHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border}
`;

const UserImages = styled.div`
    display: flex;
    align-items: center;
    // justify-content: center;
    
    span {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: -10px;
      border: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
      }
    }
    span.img-avatar{
        background-color: ${({theme}) => theme.CorporateTheme.colors.stackBg};
        color: #ffffff;
        font-size: 12px;
    }
`;

const Divider = styled.span`
    width: 1px;
    background-color: ${({theme}) => theme.CorporateTheme.colors.border};

`;

const ConCriteria = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${({theme}) => theme.CorporateTheme.colors.headerBG};
    border-radius: 5px;
    padding: 15px;
`;

export default SingleCriteriaResultBox